module.exports = __webpack_public_path__ + "img/footer-last.a7c888ba.png";